import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=a46adc2a&lang=pug&"
import script from "./Document.vue?vue&type=script&lang=babel&"
export * from "./Document.vue?vue&type=script&lang=babel&"
import style0 from "./Document.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Document.vue"
export default component.exports